
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface HologramSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  availableHolograms: any[] | undefined;
  isLoading: boolean;
  disabled?: boolean;
}

export function HologramSelect({ 
  value, 
  onValueChange, 
  availableHolograms, 
  isLoading,
  disabled 
}: HologramSelectProps) {
  return (
    <div className="space-y-2">
      <label htmlFor="hologramNumber" className="text-sm font-medium">
        Hologram Number
      </label>
      {isLoading ? (
        <div className="text-sm text-muted-foreground">Loading available hologram numbers...</div>
      ) : availableHolograms && availableHolograms.length > 0 ? (
        <Select
          value={value}
          onValueChange={onValueChange}
          disabled={disabled}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a hologram number" />
          </SelectTrigger>
          <SelectContent>
            {availableHolograms.map((hologram) => (
              <SelectItem 
                key={hologram.hologram_code} 
                value={hologram.hologram_code}
              >
                {hologram.hologram_code}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <div className="text-sm text-muted-foreground">No available hologram numbers found</div>
      )}
    </div>
  );
}
